// The colour of a company's Pennylane category (« Intérim - CHR »…), that of
// the sector labels of the prototype; any other category is grey.
const SECTOR_BADGES = [
  [/commerce|distribution|vente/i, 'SECTOR_GREEN'],
  [/chr|hôtel|hotel|restaura/i, 'SECTOR_ORANGE'],
  [/industri/i, 'SECTOR_INDIGO'],
  [/logisti/i, 'SECTOR_PURPLE'],
  [/automobile|transport/i, 'SECTOR_SLATE'],
];

export const sectorBadgeType = (label) =>
  SECTOR_BADGES.find(([pattern]) => pattern.test(label ?? ''))?.[1] ?? 'SECTOR_GREY';
